import { SignInPage } from '@backstage/core-components';
import { gitlabAuthApiRef, IdentityApi } from '@backstage/core-plugin-api';

const providers = [
  {
    id: 'gitlab',
    title: 'GitLab',
    message: 'Sign in with GitLab',
    apiRef: gitlabAuthApiRef,
    environment: 'production',   // ✅ correct property name
  },
];

export const CustomSignInPage = () => (
  <SignInPage
    auto
    providers={providers}
    onSignInSuccess={(_: IdentityApi) => {
      console.log('Signed in successfully');
    }}
  />
);
